define('OutSystems/ClientRuntime/Exceptions',["require", "exports", "tslib"], function (require, exports, tslib_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.isApplicationOffline = exports.isSystem = exports.getException = exports.getExceptionInfo = exports.getStack = exports.getMessage = exports.isInstanceOf = exports.Exceptions = void 0;
    var Exceptions;
    (function (Exceptions) {
        Exceptions.CustomError = function (message) {
            var _this = Error.call(this, message);
            if (typeof Object.setPrototypeOf === "function") {
                Object.setPrototypeOf(_this, this.constructor.prototype);
            }
            else {
                _this.__proto__ = this.constructor.prototype;
            }
            if (!("stack" in this)) {
                if (Error.captureStackTrace) {
                    Error.captureStackTrace(this, this.constructor);
                }
            }
        };
        Exceptions.CustomError.prototype = Error.prototype;
        var Exception = (function (_super) {
            tslib_1.__extends(Exception, _super);
            function Exception(message, extraStack) {
                var _this_1 = _super.call(this, message) || this;
                _this_1.extraStack = extraStack;
                _this_1.message = message;
                _this_1.name = "Exception";
                return _this_1;
            }
            return Exception;
        }(Exceptions.CustomError));
        Exceptions.Exception = Exception;
        var ServerException = (function (_super) {
            tslib_1.__extends(ServerException, _super);
            function ServerException(specificType, message, extraStack) {
                var _this_1 = _super.call(this, message, extraStack) || this;
                _this_1.specificType = specificType;
                _this_1.name = specificType;
                return _this_1;
            }
            return ServerException;
        }(Exception));
        Exceptions.ServerException = ServerException;
        var DataBaseException = (function (_super) {
            tslib_1.__extends(DataBaseException, _super);
            function DataBaseException(specificType, message, extraStack) {
                var _this_1 = _super.call(this, message, extraStack) || this;
                _this_1.specificType = specificType;
                _this_1.name = specificType;
                return _this_1;
            }
            return DataBaseException;
        }(Exception));
        Exceptions.DataBaseException = DataBaseException;
        var OpenDatabaseException = (function (_super) {
            tslib_1.__extends(OpenDatabaseException, _super);
            function OpenDatabaseException(message, extraStack) {
                return _super.call(this, "OpenDatabaseException", message, extraStack) || this;
            }
            return OpenDatabaseException;
        }(DataBaseException));
        Exceptions.OpenDatabaseException = OpenDatabaseException;
        var CommunicationException = (function (_super) {
            tslib_1.__extends(CommunicationException, _super);
            function CommunicationException(message, extraStack) {
                var _this_1 = _super.call(this, message, extraStack) || this;
                _this_1.name = "CommunicationException";
                return _this_1;
            }
            return CommunicationException;
        }(Exception));
        Exceptions.CommunicationException = CommunicationException;
        var NumberOverflowException = (function (_super) {
            tslib_1.__extends(NumberOverflowException, _super);
            function NumberOverflowException(message, extraStack) {
                var _this_1 = _super.call(this, message, extraStack) || this;
                _this_1.name = "NumberOverflowException";
                return _this_1;
            }
            NumberOverflowException.prototype.valueOf = function () {
                return this.name + ": " + this.message;
            };
            return NumberOverflowException;
        }(Exception));
        Exceptions.NumberOverflowException = NumberOverflowException;
        var InvalidJavascriptType = (function (_super) {
            tslib_1.__extends(InvalidJavascriptType, _super);
            function InvalidJavascriptType(message, extraStack) {
                var _this_1 = _super.call(this, message, extraStack) || this;
                _this_1.name = "InvalidJavascriptType";
                return _this_1;
            }
            InvalidJavascriptType.prototype.valueOf = function () {
                return this.name + ": " + this.message;
            };
            return InvalidJavascriptType;
        }(Exception));
        Exceptions.InvalidJavascriptType = InvalidJavascriptType;
        var SecurityException = (function (_super) {
            tslib_1.__extends(SecurityException, _super);
            function SecurityException(message, extraStack) {
                var _this_1 = _super.call(this, message, extraStack) || this;
                _this_1.name = "SecurityException";
                return _this_1;
            }
            return SecurityException;
        }(Exception));
        Exceptions.SecurityException = SecurityException;
        var InvalidLoginException = (function (_super) {
            tslib_1.__extends(InvalidLoginException, _super);
            function InvalidLoginException(message, extraStack) {
                var _this_1 = _super.call(this, message, extraStack) || this;
                _this_1.name = "InvalidLoginException";
                return _this_1;
            }
            return InvalidLoginException;
        }(SecurityException));
        Exceptions.InvalidLoginException = InvalidLoginException;
        var NotRegisteredException = (function (_super) {
            tslib_1.__extends(NotRegisteredException, _super);
            function NotRegisteredException(specificType, message, extraStack) {
                var _this_1 = _super.call(this, message, extraStack) || this;
                _this_1.specificType = specificType;
                _this_1.name = specificType;
                return _this_1;
            }
            return NotRegisteredException;
        }(SecurityException));
        Exceptions.NotRegisteredException = NotRegisteredException;
        var SystemException = (function (_super) {
            tslib_1.__extends(SystemException, _super);
            function SystemException(message, extraStack) {
                var _this_1 = _super.call(this, message, extraStack) || this;
                _this_1.name = "SystemException";
                return _this_1;
            }
            return SystemException;
        }(Exception));
        Exceptions.SystemException = SystemException;
        var IgnorableSystemException = (function (_super) {
            tslib_1.__extends(IgnorableSystemException, _super);
            function IgnorableSystemException(message, extraStack) {
                var _this_1 = _super.call(this, message, extraStack) || this;
                _this_1.name = "IgnorableSystemException";
                return _this_1;
            }
            return IgnorableSystemException;
        }(SystemException));
        Exceptions.IgnorableSystemException = IgnorableSystemException;
        var ViewHasChangedException = (function (_super) {
            tslib_1.__extends(ViewHasChangedException, _super);
            function ViewHasChangedException(message, extraStack) {
                var _this_1 = _super.call(this, message, extraStack) || this;
                _this_1.name = "ViewHasChangedException";
                return _this_1;
            }
            return ViewHasChangedException;
        }(IgnorableSystemException));
        Exceptions.ViewHasChangedException = ViewHasChangedException;
        var OutOfOrderException = (function (_super) {
            tslib_1.__extends(OutOfOrderException, _super);
            function OutOfOrderException(message, extraStack) {
                var _this_1 = _super.call(this, message, extraStack) || this;
                _this_1.name = "OutOfOrderException";
                return _this_1;
            }
            return OutOfOrderException;
        }(IgnorableSystemException));
        Exceptions.OutOfOrderException = OutOfOrderException;
        var OutOfContextException = (function (_super) {
            tslib_1.__extends(OutOfContextException, _super);
            function OutOfContextException(message, extraStack) {
                var _this_1 = _super.call(this, message, extraStack) || this;
                _this_1.name = "OutOfContextException";
                return _this_1;
            }
            return OutOfContextException;
        }(IgnorableSystemException));
        Exceptions.OutOfContextException = OutOfContextException;
        var RedirectOccurredException = (function (_super) {
            tslib_1.__extends(RedirectOccurredException, _super);
            function RedirectOccurredException(message, extraStack) {
                var _this_1 = _super.call(this, message, extraStack) || this;
                _this_1.name = "RedirectOccurredException";
                return _this_1;
            }
            return RedirectOccurredException;
        }(IgnorableSystemException));
        Exceptions.RedirectOccurredException = RedirectOccurredException;
        var UnhandledOrIgnoredErrorInEventException = (function (_super) {
            tslib_1.__extends(UnhandledOrIgnoredErrorInEventException, _super);
            function UnhandledOrIgnoredErrorInEventException(message, extraStack) {
                var _this_1 = _super.call(this, message, extraStack) || this;
                _this_1.name = "UnhandledOrIgnoredErrorInEventException";
                return _this_1;
            }
            Object.defineProperty(UnhandledOrIgnoredErrorInEventException.prototype, "handleErrorResult", {
                get: function () {
                    return this._handleErrorResult;
                },
                enumerable: false,
                configurable: true
            });
            UnhandledOrIgnoredErrorInEventException.create = function (handleErrorResult, message, extraStack) {
                var result = new UnhandledOrIgnoredErrorInEventException(message, extraStack);
                result._handleErrorResult = handleErrorResult;
                return result;
            };
            UnhandledOrIgnoredErrorInEventException.ignore = function (error) {
                if (!isInstanceOf(error, UnhandledOrIgnoredErrorInEventException)) {
                    throw error;
                }
            };
            return UnhandledOrIgnoredErrorInEventException;
        }(IgnorableSystemException));
        Exceptions.UnhandledOrIgnoredErrorInEventException = UnhandledOrIgnoredErrorInEventException;
        var ApplicationBackendUnavailableException = (function (_super) {
            tslib_1.__extends(ApplicationBackendUnavailableException, _super);
            function ApplicationBackendUnavailableException(message, extraStack) {
                var _this_1 = _super.call(this, message, extraStack) || this;
                _this_1.name = "ApplicationBackendUnavailableException";
                return _this_1;
            }
            return ApplicationBackendUnavailableException;
        }(SystemException));
        Exceptions.ApplicationBackendUnavailableException = ApplicationBackendUnavailableException;
        var LicensingException = (function (_super) {
            tslib_1.__extends(LicensingException, _super);
            function LicensingException(message, extraStack) {
                var _this_1 = _super.call(this, message, extraStack) || this;
                _this_1.name = "LicensingException";
                return _this_1;
            }
            return LicensingException;
        }(SystemException));
        Exceptions.LicensingException = LicensingException;
        var IncompatibleProducerException = (function (_super) {
            tslib_1.__extends(IncompatibleProducerException, _super);
            function IncompatibleProducerException(message, extraStack) {
                var _this_1 = _super.call(this, message, extraStack) || this;
                _this_1.name = "IncompatibleProducerException";
                return _this_1;
            }
            return IncompatibleProducerException;
        }(SystemException));
        Exceptions.IncompatibleProducerException = IncompatibleProducerException;
        var ControllerDisposedException = (function (_super) {
            tslib_1.__extends(ControllerDisposedException, _super);
            function ControllerDisposedException(message, extraStack) {
                var _this_1 = _super.call(this, message, extraStack) || this;
                _this_1.name = "ControllerDisposedException";
                return _this_1;
            }
            return ControllerDisposedException;
        }(IgnorableSystemException));
        Exceptions.ControllerDisposedException = ControllerDisposedException;
        var AbortActivityChangeException = (function (_super) {
            tslib_1.__extends(AbortActivityChangeException, _super);
            function AbortActivityChangeException(message, extraStack) {
                var _this_1 = _super.call(this, message, extraStack) || this;
                _this_1.name = "AbortActivityChangeException";
                return _this_1;
            }
            return AbortActivityChangeException;
        }(Exception));
        Exceptions.AbortActivityChangeException = AbortActivityChangeException;
        var UserException = (function (_super) {
            tslib_1.__extends(UserException, _super);
            function UserException(specificType, message, extraStack) {
                var _this_1 = _super.call(this, message, extraStack) || this;
                _this_1.specificType = specificType;
                _this_1.name = specificType;
                return _this_1;
            }
            return UserException;
        }(Exception));
        Exceptions.UserException = UserException;
    })(Exceptions = exports.Exceptions || (exports.Exceptions = {}));
    function isInstanceOf(ex, type, specificType) {
        if (specificType === void 0) { specificType = ""; }
        if (type === Exceptions.Exception) {
            return true;
        }
        if (ex instanceof type) {
            if (specificType !== "") {
                if (ex.specificType) {
                    return ex.specificType === specificType;
                }
                return false;
            }
            return true;
        }
        return false;
    }
    exports.isInstanceOf = isInstanceOf;
    function getMessage(ex) {
        if (ex === undefined) {
            return "";
        }
        else if (ex instanceof Error) {
            return ex.message;
        }
        else {
            var message = ex.toString();
            if (message === "[object SQLError]") {
                return ex.message.toString();
            }
            else {
                return message;
            }
        }
    }
    exports.getMessage = getMessage;
    function getStack(ex) {
        var stack = (ex.extraStack !== undefined ? ex.extraStack + "\r\n " : "") + (ex.stack || "");
        return stack || "";
    }
    exports.getStack = getStack;
    function getExceptionInfo(error) {
        var info = {
            name: error.name,
            message: getMessage(error),
            stack: getStack(error),
            extraStack: error instanceof Exceptions.Exception ? error.extraStack : undefined,
        };
        return info;
    }
    exports.getExceptionInfo = getExceptionInfo;
    function getException(info) {
        if (!!info.name) {
            if (!!info.specificType) {
                return new Exceptions[info.name](info.specificType, info.message, info.extraStack);
            }
            else {
                return new Exceptions[info.name](info.message, info.extraStack);
            }
        }
        else {
            return new Exceptions.Exception(info.message, info.extraStack);
        }
    }
    exports.getException = getException;
    function isSystem(ex) {
        return isInstanceOf(ex, Exceptions.SystemException);
    }
    exports.isSystem = isSystem;
    function isApplicationOffline(ex) {
        return isInstanceOf(ex, Exceptions.LicensingException);
    }
    exports.isApplicationOffline = isApplicationOffline;
});
//# sourceMappingURL=Exceptions.js.map;
